<template>
  <navigation-menu-item target-path="account-settings" title="הגדרות מנוי" v-on:navigate="$emit('navigate')" :icon="icon"/>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import promotions from '@/constants/promotions';
import { SUBSCRIPTION_STATES } from '@/constants/subscription-state';
import NavigationMenuItem from './NavigationMenuItem.vue';

export default {
  name: 'AccountSettingsMenuItem',
  components: { NavigationMenuItem },
  computed: {
    ...mapState('discountPromotion', ['eligibleForDiscountPromotion']),
    ...mapState('benefits', ['benefitType', 'benefitPromotion']),
    ...mapState('subscriptionState', ['subscriptionState']),
    eligibleSubscriptionState() {
      return _.includes([SUBSCRIPTION_STATES.TRIAL, SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL], this.subscriptionState);
    },
    showDiscountPromotionIcon() {
      return (this.eligibleForDiscountPromotion || this.isDiscountBenefit) && this.eligibleSubscriptionState;
    },
    showBenefitIcon() {
      return this.benefitType && this.eligibleSubscriptionState && !this.isDiscountBenefit;
    },
    isDiscountBenefit() {
      return this.benefitPromotion === promotions.PROMOTION_NAMES.DISCOUNT_FIRST_MONTH_FREE;
    },
    icon() {
      if (this.showBenefitIcon) {
        return 'benefit.svg';
      }
      if (this.showDiscountPromotionIcon) {
        return 'discount-benefit.svg';
      }
      return null;
    },
  },
};
</script>
